module.exports = __webpack_public_path__ + "static/media/International-SOS.37dd96a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/International-SOS.png
// module id = 319
// module chunks = 0